import Vue from 'vue';

/** Presentation only. Playback remains owned by the existing runtime Audio. */
export const saltPlayerPresentation = Vue.observable({
  active: false,
  progress: 0,
  left: 0,
  baseLeft: 0,
  coverMoving: false,
  menuOpen: false,
});

export function requestSaltPlayerMenu(anchor: Element, point?: { x: number; y: number }) {
  const rect = anchor.getBoundingClientRect();
  const dock = anchor.closest('#bottom-bar');
  const top = dock ? dock.getBoundingClientRect().top - 8 : Infinity;
  window.dispatchEvent(new CustomEvent('simple-music:host-player-menu', { detail: {
    x: point?.x ?? rect.left,
    y: Math.max(10, Math.min(point?.y ?? rect.top, top)),
  } }));
}
